import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { KanbanComponent } from './kanban/kanban.component';
import { AppComponent } from './app.component';
import { GravacaoComponent } from './gravacao/gravacao.component';
import { AudioRecordingService } from './audio-recording.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProjetosComponent } from './projetos/projetos.component';
import { LoginComponent } from './login/login.component';
import { RecuperacaosenhaComponent } from './recuperacaosenha/recuperacaosenha.component';
import { CadastroComponent } from './cadastro/cadastro.component';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { CadastroProjetoComponent } from './cadastro-projeto/cadastro-projeto.component';
import { WebStorageModule } from 'ngx-store';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CourseDialogComponent } from './kanban/dialog-overview-example-dialog';
import { MaterializeComponentModule } from './materialize.module';
// ES6 Modules or TypeScript
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CryptService } from './crypt.service';

//export const options: any = IConfig;

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MAT_DIALOG_DEFAULT_OPTIONS
} from '@angular/material';



@NgModule({
  exports: [
    // Material
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatNativeDateModule,
    MatTabsModule
  ],
  providers: [
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}}
  ]
})
export class MaterialModule {}

import {NgxMaskModule, IConfig} from 'ngx-mask-2';
import { TemplateComponent } from './template/template.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  imports: [
    BrowserModule,
    FormsModule, 
    ReactiveFormsModule, 
    HttpClientModule,
    BrowserAnimationsModule,
    WebStorageModule,
    DragDropModule,
    MaterializeComponentModule,
    MaterialModule,
    AppRoutingModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: 'modal-content',
      confirmButtonClass: 'btn btn-primary',
      cancelButtonClass: 'btn'
    }),
    NgxMaskModule.forRoot(options)
  ],
  entryComponents: [CourseDialogComponent],
  declarations: [
    AppComponent,
    CourseDialogComponent,
    KanbanComponent,
    GravacaoComponent,
    ProjetosComponent,
    LoginComponent,
    CadastroComponent,
    CadastroProjetoComponent,
    RecuperacaosenhaComponent,
    TemplateComponent
  ],
  providers: [AuthService, AuthGuard, AudioRecordingService, CryptService],
  bootstrap: [AppComponent],
  schemas :[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}